import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetEmployeePenaltyModel } from "@core/model/query-model-employee-penalty";
import { employeePenaltyFormDefault } from "./form.default";
import { EmployeePenaltyFormSchema } from "./form.rule";

export const useFormDefaultEmployeePenalty = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetEmployeePenaltyModel | undefined) => {
    return !cachedValue
      ? employeePenaltyFormDefault
     : ({
        userCode: cachedValue.user_code,
        bucketCode: cachedValue.bucket_code,
        amount: cachedValue.amount,
        effectivityDate: formatDate(cachedValue.effectivity_date) as any,
        remarks: cachedValue.remarks,
      } as EmployeePenaltyFormSchema);
  };

  return {
    getDefault,
  };
};
